import css from 'styled-jsx/css';
import { rgba } from 'common/styling/theme';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .CurrentIBProgramsItem {
    padding: 20px;
    margin-bottom: rem(25px);
    @include respond-to(sm) {
      padding: 15px 10px;
    }
    background: white;
    border-radius: 16px;
    border: 1px solid rgba(44, 0, 143, 0.2);
    overflow: hidden;
    transition: all 0.3s ease;
  }

  .program-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 15px;
  }

  .CurrentIBProgramsItem__partnerCode {
    margin-bottom: rem(15px);
    font-size: rem(16px);
    span {
      font-size: rem(20px);
      display: inline-block;
      margin-left: rem(5px);
      font-weight: bold;
    }
  }

  .currentIBProgram {
    display: flex;
    justify-content: space-between;
  }

  .program-name {
    font-size: 14px;
    margin-bottom: 10px;
    color: #333;
    font-weight: bold;
    span {
      font-weight: normal;
    }
    display: flex;
  }

  .program-limitation {
    margin-left: 20px;
    font-weight: normal;
  }

  .expand-all-btn {
    font-size: 18px;
    font-weight: bold;
    color: #2c008f;
    transform: rotate(0deg);
    transition: transform 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
  }

  .expand-all-btn.expanded {
    transform: rotate(90deg);
  }

  /* 区块通用样式 */
  .section {
    margin-bottom: 30px;
    padding: 16px;
    background: white;
  }

  .section-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
  }

  .section-title {
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 1.32;
    margin: 0;
  }

  .info-icon-container {
    position: relative;
    display: inline-block;
    margin-left: 8px;
  }

  .info-icon {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
  }

  .tooltip {
    position: absolute;
    left: calc(100% + 8px);
    top: 50%;
    transform: translateY(-50%);
    background: #333;
    color: white;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 12px;
    max-width: 500px;
    white-space: nowrap;
    white-space: normal;
    width: max-content;
    z-index: 1000;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .tooltip::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(-100%, -50%);
    border: 5px solid transparent;
    border-right-color: #333;
  }

  .arrow-icon {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #333;
    transition: transform 0.3s ease;
    cursor: pointer;
  }

  .arrow-icon.expanded {
    transform: rotate(90deg);
  }

  /* 奖励卡片样式 */
  .rewards-card {
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }

  .rewards-card-pnl {
    border-radius: 12px;
    border: 1px solid #BCBEC0;
    overflow: hidden;
    width: 290px;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rewards-header {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
    padding: 12px 20px;
    background: rgba(245, 245, 245, 0.5);
  }

  .header-text {
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 1.32;
    color: rgba(0, 0, 0, 0.8);
  }

  .rewards-body {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
    padding: 15px 20px;
  }

  .rewards-body-pnl {
    gap: 20px;
    padding: 15px 20px;
  }

  .reward-value {
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.32;
    color: #000000;
  }

  .reward-value-pnl {
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 700;
    font-size: 20px;
    line-height: 1.32;
    color: #000000;
  }

  /* Tiered Rebate Styles */
  .tiered-rebate-container {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .tiered-rebate-card {
    width: 290px;
    border: 1px solid #BCBEC0;
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .tiered-rebate-percentage {
    padding: 40px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
  }

  .tiered-rebate-range {
    padding: 20px;
    background: rgba(124, 158, 251, 0.3);
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.32;
    color: #000000;
    text-align: center;
  }

  /* 异常表格样式 */
  .exceptions-table {
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }

  .table-header {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
    padding: 12px 20px;
    background: rgba(245, 245, 245, 0.5);
  }

  .table-header-cell {
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 1.32;
    color: rgba(0, 0, 0, 0.8);
  }

  .table-row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
    padding: 15px 20px;
    border-top: 1px solid rgba(0, 0, 0, 0.15);
    align-items: center;
  }

  .table-cell {
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.32;
    color: #000000;
  }

  .reward-condition {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .reward-condition-text {
    font-size: 11px;
    color: rgba(0, 0, 0, 0.7);
  }

  .reward-value-1 {
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 700;
    font-size: 12px;
    line-height: 1.32;
    color: #000000;
  }

  /* Sub IB 设置样式 */
  .subib-settings {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .subib-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    background: rgba(245, 245, 245, 0.5);
    border-radius: 8px;
  }

  .subib-level {
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }

  .subib-value {
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 700;
    font-size: 16px;
    color: #2C008F;
  }

  /* 响应式设计 */
  @include respond-to(lg) {
    .rewards-header,
    .rewards-body,
    .table-header,
    .table-row {
      grid-template-columns: 1fr;
      gap: 10px;
    }

    .section-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }
  }

  @include respond-to(sm) {
    .section {
      padding: 12px;
    }

    .rewards-header,
    .rewards-body,
    .table-header,
    .table-row {
      padding: 10px;
    }
  }
`;

const getDynamicStyles = ({ colors, border }) => {
  return css`
    .section {
      border-color: ${rgba([colors.primary.rgb, 0.2])};
    }

    .rewards-card,
    .exceptions-table {
      border-color: ${rgba([colors.black.rgb, 0.15])};
    }

    .subib-value {
      color: ${colors.primary.hex};
    }
  `;
};

export { staticStyles, getDynamicStyles };
